module.exports = __webpack_public_path__ + "img/278-9848a4.png";